import React from 'react'
import styled from 'styled-components'

import Colors from '../../colors';

export default styled.div`
  flex: 1;
  
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
  
  overflow: hidden;
  
  h1 {
    font-size: 3rem;
  }
  
  h2 {
    font-size: 2.6rem;
  }
  
  h3 {
    font-size: 2.3rem;
  }

  blockquote {
    font-size: 2.4rem;
    color: ${Colors.grey};
  }

  li {
    font-size: ${({size}) => {
  switch (size) {
    case 'big':
      return '4rem';
    case 'small':
      return '2.2rem';
    case 'xsmall':
      return '1rem';
    default:
      return '2.7rem'
  }
}};
    padding-bottom: 30px;
    margin-left: 60px;
  }

  ul {
    li {
      ul {
        li {
          padding: 0;
          margin: 0;
        }
      }
    }
  }
  
  blockquote {
    margin: 0 15%;
    
    &strong {
      font-weight: bold;
    }
  }

  pre {
    font-size: ${({size}) => {
      switch (size) {
        case 'big':
          return '4rem';
        case 'small':
          return '1.2rem';
        case 'xsmall':
          return '1rem';
        default:
          return '2.5rem'
      }
    }};
  }
`